import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Modal, Grid, Typography, IconButton } from "@mui/material";
import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { colors } from "../components/Theme/WebTheme";
import moment from "moment/min/moment-with-locales";
import Switch from "@mui/material/Switch";
import { useNavigate,useLocation } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {FONT_FAMILY, SECONDORY_COLOR } from "../common/sharedFunctions";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import BlankTable from '../components/Table/BlankTable';
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
import { getLangKey } from "common/src/other/getLangKey";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function CarsList() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const userdata = useSelector((state) => state.usersdata);
  const auth = useSelector((state) => state.auth);
  const { updateUserCar, editCar} = api;
  const [driversObj, setDriversObj] = useState();
  const [data, setData] = useState([]);
  const carlistdata = useSelector((state) => state.carlistdata);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [role, setRole] = useState(null);
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)

  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  useEffect(() => {
    if (role !== "driver" && userdata.users) {
      let arr = userdata.users.filter(
        (user) =>
          user.usertype === "driver" &&
          ((role === "fleetadmin" &&
            user.fleetadmin &&
            user.fleetadmin === auth.profile.uid) ||
            role === "admin")
      );
      let obj = {}; 
      for (let i = 0; i < arr.length; i++) {
        let user = arr[i];
        obj[user.id] = `${user.firstName} ${user.lastName} (${
          settings.AllowCriticalEditsAdmin ? user.mobile : t("hidden_demo")
        }) ${settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo")}`;
      }
      setDriversObj(obj);
    }
  }, [
    userdata.users,
    settings.AllowCriticalEditsAdmin,
    role,
    auth.profile.uid,
    t,
  ]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (carlistdata?.cars && driversObj) { 
   
      const updatedData = carlistdata.cars.map((car) => ({
        ...car,
        driverName: driversObj[car?.driver] || " ",  
      }));
  
      setData(updatedData);
    } else {
      setData([]);
    }
  }, [carlistdata?.cars, driversObj]);

  // State for individual modals
  const [carImageModal, setCarImageModal] = useState(false);
  const [insuranceCopyModal, setInsuranceCopyModal] = useState(false);
  const [pucCopyModal, setPucCopyModal] = useState(false);
  const [fitnessDocumentModal, setFitnessDocumentModal] = useState(false);
  const [vehiclePermitCopyModal, setVehiclePermitCopyModal] = useState(false);
  const [vehicleImageBackModal, setVehicleImageBackModal] = useState(false);
  const [registrationImageModal, setRegistrationImageModal] = useState(false);
  const [registrationImageBackModal, setRegistrationImageBackModal] = useState(false);
  
  // State for selected images
  const [selectedCarImage, setSelectedCarImage] = useState(null);
  const [selectedInsuranceCopy, setSelectedInsuranceCopy] = useState(null);
  const [selectedPucCopy, setSelectedPucCopy] = useState(null);
  const [selectedFitnessDocument, setSelectedFitnessDocument] = useState(null);
  const [selectedVehiclePermitCopy, setSelectedVehiclePermitCopy] = useState(null);
  const [selectedVehicleImageBack, setSelectedVehicleImageBack] = useState(null);
  const [selectedRegistrationImage, setSelectedRegistrationImage] = useState(null);
  const [selectedRegistrationImageBack, setSelectedRegistrationImageBack] = useState(null);
  
  // State for selected car data
  const [selectedCar, setSelectedCar] = useState(null);
  
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  // Individual click handlers for each image type
  const handleCarImageClick = (imageUrl, carData) => {
    setSelectedCarImage(imageUrl);
    setSelectedCar(carData);
    setCarImageModal(true);
  };

  const handleInsuranceCopyClick = (imageUrl, carData) => {
    setSelectedInsuranceCopy(imageUrl);
    setSelectedCar(carData);
    setInsuranceCopyModal(true);
  };

  const handlePucCopyClick = (imageUrl, carData) => {
    setSelectedPucCopy(imageUrl);
    setSelectedCar(carData);
    setPucCopyModal(true);
  };

  const handleFitnessDocumentClick = (imageUrl, carData) => {
    setSelectedFitnessDocument(imageUrl);
    setSelectedCar(carData);
    setFitnessDocumentModal(true);
  };

  const handleVehiclePermitCopyClick = (imageUrl, carData) => {
    setSelectedVehiclePermitCopy(imageUrl);
    setSelectedCar(carData);
    setVehiclePermitCopyModal(true);
  };

  const handleVehicleImageBackClick = (imageUrl, carData) => {
    setSelectedVehicleImageBack(imageUrl);
    setSelectedCar(carData);
    setVehicleImageBackModal(true);
  };

  const handleRegistrationImageClick = (imageUrl, carData) => {
    setSelectedRegistrationImage(imageUrl);
    setSelectedCar(carData);
    setRegistrationImageModal(true);
  };

  const handleRegistrationImageBackClick = (imageUrl, carData) => {
    setSelectedRegistrationImageBack(imageUrl);
    setSelectedCar(carData);
    setRegistrationImageBackModal(true);
  };

  // Handle image upload
  const handleImageUpload = (event, imageType) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      
      reader.onload = (e) => {
        // Update the preview image
        switch(imageType) {
          case 'carImage':
            setSelectedCarImage(e.target.result);
            break;
          case 'insuranceCopy':
            setSelectedInsuranceCopy(e.target.result);
            break;
          case 'pucCopy':
            setSelectedPucCopy(e.target.result);
            break;
          case 'fitnessDocument':
            setSelectedFitnessDocument(e.target.result);
            break;
          case 'vehiclePermitCopy':
            setSelectedVehiclePermitCopy(e.target.result);
            break;
          case 'vehicleImageBack':
            setSelectedVehicleImageBack(e.target.result);
            break;
            case 'registrationImage':
            setSelectedRegistrationImage(e.target.result);
            break;
            case 'registrationImageBack':
            setSelectedRegistrationImageBack(e.target.result);
            break;
          default:
            break;
        }
      };
      
      reader.readAsDataURL(file);
      
      // Update the car data with the new image
      const updatedCar = { ...selectedCar };
      
      switch(imageType) {
        case 'carImage':
          // For main car image, we use the update method
          dispatch(editCar({ ...updatedCar, car_image: file }, "UpdateImage"));
          break;
        case 'insuranceCopy':
          dispatch(api.updateCarWithImages(updatedCar, null, { insuranceCopyBlob: file }));
          break;
        case 'pucCopy':
          dispatch(api.updateCarWithImages(updatedCar, null, { pucCopyBlob: file }));
          break;
        case 'fitnessDocument':
          dispatch(api.updateCarWithImages(updatedCar, null, { fitnessDocumentBlob: file }));
          break;
        case 'vehiclePermitCopy':
          dispatch(api.updateCarWithImages(updatedCar, null, { vehiclePermitCopyBlob: file }));
          break;
        case 'vehicleImageBack':
          dispatch(api.updateCarWithImages(updatedCar, null, { vehicleImageBackBlob: file }));
          break;
          case 'registrationImage':
          dispatch(api.updateCarWithImages(updatedCar, null, { registrationImageBlob: file }));
          break;
          case 'registrationImageBack':
          dispatch(api.updateCarWithImages(updatedCar, null, { registrationImageBackBlob: file }));
          break;
        default:
          break;
      }
      
      // Show success message
      setCommonAlert({ open: true, msg: t("image_updated_successfully") });
    }
  };

  const columns = [
    {
      title: t("createdAt"),
      field: "createdAt",
      editable: "never",
      defaultSort: "desc",
      render: (rowData) =>
        rowData.createdAt ? moment(rowData.createdAt).format("lll") : null,
    },
    {
      title: t("driver"),
      field: "driverName",  
      editable: role === "driver" ? "never" : "always",
      render: (rowData) => rowData.driverName || null,
      
      exportTransformer: (rowData) => rowData.driverName,
      hidden: role === "driver",
    },
    { title: t("car_type"), field: "carType",
      render: (rowData) =>
        rowData.createdAt ? t(getLangKey(rowData.carType)) : null,
    },
    { title: t("vehicle_reg_no"), field: "vehicleNumber" },
    { title: t("vehicle_model_name"), field: "vehicleMake" },
    { title: t("vehicle_model_no"), field: "vehicleModel" },
    { title: t("other_info"), field: "other_info" },
    {
      title: t("image"),
      field: "car_image",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.car_image ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleCarImageClick(rowData.car_image, rowData);
            }}
          >
            <img alt="CarImage" src={rowData.car_image} style={{ width: 50 }} />
          </button>
        ) : null,
    },
    {
      title: t("insurance_copy"),
      field: "insurance_copy",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.insuranceCopy ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleInsuranceCopyClick(rowData.insuranceCopy, rowData);
            }}
          >
            <img alt="insuranceCopy" src={rowData.insuranceCopy} style={{ width: 50 }} />
          </button>
        ) : null,
    },
    {
      title: t("puc_copy"),
      field: "puc_copy",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.pucCopy ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handlePucCopyClick(rowData.pucCopy, rowData);
            }}
          >
            <img alt="pucCopy" src={rowData.pucCopy} style={{ width: 50 }} />
          </button>
        ) : null,
    },
    {
      title: t("fitness_document"),
      field: "fitness_document",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.fitnessDocument ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleFitnessDocumentClick(rowData.fitnessDocument, rowData);
            }}
          >
            <img alt="fitnessDocument" src={rowData.fitnessDocument} style={{ width: 50 }} />
          </button>
        ) : null,
    },
    {
      title: t("vehicle_permit_copy"),
      field: "vehicle_permit_copy",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.vehiclePermitCopy ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleVehiclePermitCopyClick(rowData.vehiclePermitCopy, rowData);
            }}
          >
            <img alt="vehiclePermit" src={rowData.vehiclePermitCopy} style={{ width: 50 }} />
          </button>
        ) : null,
    },
    {
      title: t("vehicle_image_back"),
      field: "vehicle_image_back",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.vehicleImageBack ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleVehicleImageBackClick(rowData.vehicleImageBack, rowData);
            }}
          >
            <img alt="vehicle_image_back" src={rowData.vehicleImageBack} style={{ width: 50 }} />
          </button>
        ) : null,
    },
     {
      title: t("image_of_registration"),
      field: "image_of_registration",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.registrationImage ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleRegistrationImageClick(rowData.registrationImage, rowData);
            }}
          >
            <img alt="image_of_registration" src={rowData.registrationImage} style={{ width: 50 }} />
          </button>
        ) : null,
    },
     {
      title: t("image_of_registration_back"),
      field: "image_of_registration_back",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.registrationImageBack ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleRegistrationImageBackClick(rowData.registrationImageBack, rowData);
            }}
          >
            <img alt="image_of_registration_back" src={rowData.registrationImageBack} style={{ width: 50 }} />
          </button>
        ) : null,
    },
    {
      title: t("active_status"),
      field: "active",
      editable:  "never" ,
      type: "boolean",
      initialEditValue: true,
      render: (rowData) => (
        <Switch
        disabled
          checked={rowData.active}
          onChange={() => handelActiveStatus(rowData)}
        />
      ),
    },
    {
      title: t("approved"),
      field: "approved",
      editable: role === "admin" ? "never" : "always",
      type: "boolean",
      initialEditValue: true,
      render: (rowData) => (
        <Switch
          checked={rowData.approved}
          onChange={() => handelApproved(rowData)}
          disabled={!(settings.AllowCriticalEditsAdmin && settings.carApproval && role === "admin")}
        />
      ),
    },
  ];
  const [selectedRow, setSelectedRow] = useState(null);
  const handelApproved = (rowData) => {

    if (settings.carApproval && role === "admin") {
      dispatch(
        updateUserCar(rowData.driver, {
          carApproved: !rowData.approved,
        })
      );

      dispatch(editCar({ ...rowData, approved: !rowData.approved }, "Update"));
    }
  };
  const handelActiveStatus = (rowData) => {
    const updateData = { ...rowData, active: !rowData.active };
    return updateData;
  };
  return carlistdata.loading ? (
    <CircularLoading />
  ) : (
    <div ref={rootRef}>
    <ThemeProvider theme={theme}>
      { data?.length >0 ? 
      <MaterialTable
        title={t("cars_title")}
        columns={columns}
        onChangePage={(page)=>HandalePageChange(page)}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "8px",
          boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
          padding: "20px",
        }}
        data={data}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          initialPage:state?.pageNo,
          exportButton: true,
          rowStyle: (rowData) => ({
            backgroundColor:
              selectedRow === rowData.tableData.id ? colors.ROW_SELECTED :colors.WHITE
          }),
          ...TableStyle()
        }}
        localization={localization(t)}
        editable={{ 
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve, reject) => {
                  setTimeout(() => {
                    if (oldData.active) {
                      reject();
                      alert(t("active_car_delete"));
                    } else {
                      resolve();
                      dispatch(editCar(oldData, "Delete"));
                    }
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
        actions={[    
              {
          icon: 'add',
          tooltip: t("add_car"),
          isFreeAction: true,
          onClick: (event) => navigate(`/cars/editcar`,{state:{pageNo:currentPage}})
        },
        (rowData) => ({
          tooltip: t("edit"),
            icon: () => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginRight:0
                }}
              >
                <EditIcon />  
              </div>
            ),
            onClick: (event, rowData) =>{
              navigate(`/cars/editcar/${rowData.id}`,{state:{pageNo:currentPage}})
            }
          }),
        
        ]}
      />
      : <BlankTable title={t('cars_title')} 
      actions={[    
        {
        icon: 'add',
        tooltip: t("add_car"),
        isFreeAction: true,
            onClick: (event) => navigate(`/cars/editcar`)
      },
      ]}
      columns={columns}  data={[]} localization={localization(t)} options={TableStyle()}/>}
    </ThemeProvider> 
      {/* Car Image Modal */}
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={carImageModal}
        onClose={() => setCarImageModal(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr", maxWidth: 600 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h5" style={{ fontFamily: FONT_FAMILY, textAlign: "center" }}>
              {t("car_image")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center" }}>
            <img
              alt="Car"
              src={selectedCarImage}
              style={{ maxWidth: "100%", height: "auto", maxHeight: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center", marginTop: 20 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="car-image-upload"
              type="file"
              onChange={(e) => handleImageUpload(e, 'carImage')}
            />
            <label htmlFor="car-image-upload">
              <Button
                variant="contained"
                component="span"
                style={{ backgroundColor: colors.GREEN, fontFamily: FONT_FAMILY, marginRight: 10 }}
              >
                <CloudUploadIcon style={{ marginRight: 5 }} /> {t("edit_image")}
              </Button>
            </label>
            <Button
              onClick={() => setCarImageModal(false)}
              variant="contained"
              style={{ backgroundColor: colors.RED, fontFamily: FONT_FAMILY }}
            >
              {t("close")}
            </Button>
          </Grid>
        </Grid>
      </Modal>

      {/* Insurance Copy Modal */}
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={insuranceCopyModal}
        onClose={() => setInsuranceCopyModal(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr", maxWidth: 600 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h5" style={{ fontFamily: FONT_FAMILY, textAlign: "center" }}>
              {t("insurance_copy")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center" }}>
            <img
              alt="Insurance Copy"
              src={selectedInsuranceCopy}
              style={{ maxWidth: "100%", height: "auto", maxHeight: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center", marginTop: 20 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="insurance-copy-upload"
              type="file"
              onChange={(e) => handleImageUpload(e, 'insuranceCopy')}
            />
            <label htmlFor="insurance-copy-upload">
              <Button
                variant="contained"
                component="span"
                style={{ backgroundColor: colors.GREEN, fontFamily: FONT_FAMILY, marginRight: 10 }}
              >
                <CloudUploadIcon style={{ marginRight: 5 }} /> {t("edit_image")}
              </Button>
            </label>
            <Button
              onClick={() => setInsuranceCopyModal(false)}
              variant="contained"
              style={{ backgroundColor: colors.RED, fontFamily: FONT_FAMILY }}
            >
              {t("close")}
            </Button>
          </Grid>
        </Grid>
      </Modal>

      {/* PUC Copy Modal */}
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={pucCopyModal}
        onClose={() => setPucCopyModal(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr", maxWidth: 600 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h5" style={{ fontFamily: FONT_FAMILY, textAlign: "center" }}>
              {t("puc_copy")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center" }}>
            <img
              alt="PUC Copy"
              src={selectedPucCopy}
              style={{ maxWidth: "100%", height: "auto", maxHeight: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center", marginTop: 20 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="puc-copy-upload"
              type="file"
              onChange={(e) => handleImageUpload(e, 'pucCopy')}
            />
            <label htmlFor="puc-copy-upload">
              <Button
                variant="contained"
                component="span"
                style={{ backgroundColor: colors.GREEN, fontFamily: FONT_FAMILY, marginRight: 10 }}
              >
                <CloudUploadIcon style={{ marginRight: 5 }} /> {t("edit_image")}
              </Button>
            </label>
            <Button
              onClick={() => setPucCopyModal(false)}
              variant="contained"
              style={{ backgroundColor: colors.RED, fontFamily: FONT_FAMILY }}
            >
              {t("close")}
            </Button>
          </Grid>
        </Grid>
      </Modal>

      {/* Fitness Document Modal */}
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={fitnessDocumentModal}
        onClose={() => setFitnessDocumentModal(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr", maxWidth: 600 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h5" style={{ fontFamily: FONT_FAMILY, textAlign: "center" }}>
              {t("fitness_document")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center" }}>
            <img
              alt="Fitness Document"
              src={selectedFitnessDocument}
              style={{ maxWidth: "100%", height: "auto", maxHeight: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center", marginTop: 20 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="fitness-document-upload"
              type="file"
              onChange={(e) => handleImageUpload(e, 'fitnessDocument')}
            />
            <label htmlFor="fitness-document-upload">
              <Button
                variant="contained"
                component="span"
                style={{ backgroundColor: colors.GREEN, fontFamily: FONT_FAMILY, marginRight: 10 }}
              >
                <CloudUploadIcon style={{ marginRight: 5 }} /> {t("edit_image")}
              </Button>
            </label>
            <Button
              onClick={() => setFitnessDocumentModal(false)}
              variant="contained"
              style={{ backgroundColor: colors.RED, fontFamily: FONT_FAMILY }}
            >
              {t("close")}
            </Button>
          </Grid>
        </Grid>
      </Modal>

      {/* Vehicle Permit Copy Modal */}
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={vehiclePermitCopyModal}
        onClose={() => setVehiclePermitCopyModal(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr", maxWidth: 600 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h5" style={{ fontFamily: FONT_FAMILY, textAlign: "center" }}>
              {t("vehicle_permit_copy")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center" }}>
            <img
              alt="Vehicle Permit Copy"
              src={selectedVehiclePermitCopy}
              style={{ maxWidth: "100%", height: "auto", maxHeight: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center", marginTop: 20 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="vehicle-permit-copy-upload"
              type="file"
              onChange={(e) => handleImageUpload(e, 'vehiclePermitCopy')}
            />
            <label htmlFor="vehicle-permit-copy-upload">
              <Button
                variant="contained"
                component="span"
                style={{ backgroundColor: colors.GREEN, fontFamily: FONT_FAMILY, marginRight: 10 }}
              >
                <CloudUploadIcon style={{ marginRight: 5 }} /> {t("edit_image")}
              </Button>
            </label>
            <Button
              onClick={() => setVehiclePermitCopyModal(false)}
              variant="contained"
              style={{ backgroundColor: colors.RED, fontFamily: FONT_FAMILY }}
            >
              {t("close")}
            </Button>
          </Grid>
        </Grid>
      </Modal>

      {/* Vehicle Image Back Modal */}
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={vehicleImageBackModal}
        onClose={() => setVehicleImageBackModal(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr", maxWidth: 600 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h5" style={{ fontFamily: FONT_FAMILY, textAlign: "center" }}>
              {t("vehicle_image_back")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center" }}>
            <img
              alt="Vehicle Image Back"
              src={selectedVehicleImageBack}
              style={{ maxWidth: "100%", height: "auto", maxHeight: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center", marginTop: 20 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="vehicle-image-back-upload"
              type="file"
              onChange={(e) => handleImageUpload(e, 'vehicleImageBack')}
            />
            <label htmlFor="vehicle-image-back-upload">
              <Button
                variant="contained"
                component="span"
                style={{ backgroundColor: colors.GREEN, fontFamily: FONT_FAMILY, marginRight: 10 }}
              >
                <CloudUploadIcon style={{ marginRight: 5 }} /> {t("edit_image")}
              </Button>
            </label>
            <Button
              onClick={() => setVehicleImageBackModal(false)}
              variant="contained"
              style={{ backgroundColor: colors.RED, fontFamily: FONT_FAMILY }}
            >
              {t("close")}
            </Button>
          </Grid>
        </Grid>
      </Modal>

      {/* Registration Image  Modal */}
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={registrationImageModal}
        onClose={() => setRegistrationImageModal(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr", maxWidth: 600 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h5" style={{ fontFamily: FONT_FAMILY, textAlign: "center" }}>
              {t("image_of_registration")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center" }}>
            <img
              alt="Registration Image"
              src={selectedRegistrationImage}
              style={{ maxWidth: "100%", height: "auto", maxHeight: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center", marginTop: 20 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="registration-image-upload"
              type="file"
              onChange={(e) => handleImageUpload(e, 'registrationImage')}
            />
            <label htmlFor="registration-image-upload">
              <Button
                variant="contained"
                component="span"
                style={{ backgroundColor: colors.GREEN, fontFamily: FONT_FAMILY, marginRight: 10 }}
              >
                <CloudUploadIcon style={{ marginRight: 5 }} /> {t("edit_image")}
              </Button>
            </label>
            <Button
              onClick={() => setRegistrationImageModal(false)}
              variant="contained"
              style={{ backgroundColor: colors.RED, fontFamily: FONT_FAMILY }}
            >
              {t("close")}
            </Button>
          </Grid>
        </Grid>
      </Modal>

      {/* Registration Image Back Modal */}
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={registrationImageBackModal}
        onClose={() => setRegistrationImageBackModal(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr", maxWidth: 600 }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h5" style={{ fontFamily: FONT_FAMILY, textAlign: "center" }}>
              {t("image_of_registration_back")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center" }}>
            <img
              alt="Registration Image Back"
              src={selectedRegistrationImageBack}
              style={{ maxWidth: "100%", height: "auto", maxHeight: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: "center", marginTop: 20 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="registration-image-back-upload"
              type="file"
              onChange={(e) => handleImageUpload(e, 'registrationImage')}
            />
            <label htmlFor="registration-image-back-upload">
              <Button
                variant="contained"
                component="span"
                style={{ backgroundColor: colors.GREEN, fontFamily: FONT_FAMILY, marginRight: 10 }}
              >
                <CloudUploadIcon style={{ marginRight: 5 }} /> {t("edit_image")}
              </Button>
            </label>
            <Button
              onClick={() => setRegistrationImageBackModal(false)}
              variant="contained"
              style={{ backgroundColor: colors.RED, fontFamily: FONT_FAMILY }}
            >
              {t("close")}
            </Button>
          </Grid>
        </Grid>
      </Modal>

      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}
